import {Pagination} from './pagination.component';

export const PAGINATION_COMPONENTS = [
    Pagination
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/pagination/index.ts